import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReusableButton from '../../Reusable/PrimaryButton/PrimaryButton';
import messageLogo from "../../../assets/Message.png";

interface ErrorPopupProps {
    open: boolean;
    message: string;
    onClose: () => void;
}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ open, message, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            className="PopupContainer"
            sx={{ '& .MuiDialog-paper': { zIndex: 9999 } }}
        >
            <DialogTitle className="PopupTitle" >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <img src={messageLogo} alt="Message Icon" />
                    {message === "Credits not found"
                        ? "You do not have enough credits to generate this image. Please check your credit balance or buy more credits."
                        : message}
                </Box>
                <IconButton onClick={onClose} className="PopupCloseButton" sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                    <ReusableButton
                        onClick={() => {
                            window.location.href = '/subscription';
                            onClose();
                        }}
                        sx={{ mb: 1 }}
                    >
                        Buy Credits
                    </ReusableButton>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ErrorPopup;
